module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-3.a7033d9f.png";